import React from 'react';
import { ClockIcon, CheckIcon, XIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
const ServiceCoverage = () => {
  const appliances = [{
    name: 'Washing Machines',
    icon: '🧺'
  }, {
    name: 'Dryers',
    icon: '👕'
  }, {
    name: 'Refrigerators',
    icon: '❄️'
  }, {
    name: 'Freezers',
    icon: '🧊'
  }, {
    name: 'Ovens',
    icon: '🍳'
  }, {
    name: 'Dishwashers',
    icon: '🍽️'
  }, {
    name: 'Microwaves',
    icon: '📡'
  }, {
    name: 'TVs',
    icon: '📺'
  }, {
    name: 'Set-Top Boxes',
    icon: '📱'
  }];
  return <div className="bg-gray-50 min-h-screen" data-id="element-578">
      <div className="bg-[#1a3a6c] text-white py-16" data-id="element-579">
        <div className="container mx-auto px-4 text-center" data-id="element-580">
          <h1 className="text-4xl font-bold mb-6" data-id="element-581">Service Coverage</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-582">
            Comprehensive information about our appliance repair and maintenance
            services across the UK.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-583">
        {/* Appliances Section */}
        <section className="mb-16" data-id="element-584">
          <h2 className="text-3xl font-bold text-[#1a3a6c] mb-8 text-center" data-id="element-585">
            Appliances We Cover
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4" data-id="element-586">
            {appliances.map((appliance, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow" data-id="element-587">
                <div className="text-4xl mb-3" data-id="element-588">{appliance.icon}</div>
                <h3 className="font-medium text-[#1a3a6c]" data-id="element-589">{appliance.name}</h3>
              </div>)}
          </div>
        </section>
        {/* Service Activation Section */}
        <section className="mb-16 bg-white rounded-lg shadow-md p-8" data-id="element-590">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-591">
            Service Activation & Start Date
          </h2>
          <div className="space-y-6" data-id="element-592">
            <div className="border-b pb-4" data-id="element-593">
              <h3 className="font-bold text-lg mb-2" data-id="element-594">
                When does my cover begin?
              </h3>
              <p className="text-gray-700" data-id="element-595">
                Your protection starts immediately once your payment is
                processed. You will receive a confirmation email shortly
                afterwards.
              </p>
            </div>
            <div className="border-b pb-4" data-id="element-596">
              <h3 className="font-bold text-lg mb-2" data-id="element-597">
                Do I need to take any steps to activate my plan?
              </h3>
              <p className="text-gray-700" data-id="element-598">
                No, activation happens automatically. Your plan begins as soon
                as your purchase is complete and remains valid for 12 months.
              </p>
            </div>
            <div data-id="element-599">
              <h3 className="font-bold text-lg mb-2" data-id="element-600">
                When does my coverage end?
              </h3>
              <p className="text-gray-700" data-id="element-601">
                Your plan expires exactly 12 months later at 23:59 on the final
                day, unless you renew it beforehand.
              </p>
            </div>
          </div>
        </section>
        {/* Request Repair Section */}
        <section className="mb-16 bg-white rounded-lg shadow-md p-8" data-id="element-602">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-603">
            How Do I Request a Repair?
          </h2>
          <p className="mb-4 text-gray-700" data-id="element-604">Please contact us by:</p>
          <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-605">
            <div className="bg-gray-50 p-4 rounded-md flex items-center" data-id="element-606">
              <PhoneIcon size={20} className="text-[#f97316] mr-2" data-id="element-607" />
              <span className="font-medium" data-id="element-608">0800 055 4969</span>
            </div>
            <div className="bg-gray-50 p-4 rounded-md flex items-center" data-id="element-609">
              <MailIcon size={20} className="text-[#f97316] mr-2" data-id="element-610" />
              <span className="font-medium" data-id="element-611">raimanish3080@gmail.com</span>
            </div>
          </div>
          <p className="text-gray-700" data-id="element-612">
            Our team will organise your repair appointment, usually within 24 to
            48 hours.
          </p>
        </section>
        {/* Coverage Details Section */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-613">
          <section className="bg-white rounded-lg shadow-md p-8" data-id="element-614">
            <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-615">
              What's Included?
            </h2>
            <ul className="space-y-3" data-id="element-616">
              {['Unlimited repair visits and callouts for appliances covered during your 12-month plan', 'All labour costs are covered', 'Replacement parts provided when available', 'Engineer appointments are generally booked within 24–48 hours after reporting a fault', 'Coverage includes mechanical and electrical faults'].map((item, index) => <li key={index} className="flex items-start" data-id="element-617">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-618" />
                  <span className="text-gray-700" data-id="element-619">{item}</span>
                </li>)}
            </ul>
          </section>
          <section className="bg-white rounded-lg shadow-md p-8" data-id="element-620">
            <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-621">
              What's Not Covered?
            </h2>
            <ul className="space-y-3" data-id="element-622">
              {['Cosmetic damage or normal wear and tear of appliances', 'Faults that existed prior to your plan start date', 'Damage caused by misuse or unauthorised repairs', 'Appliances older than 10 years at the start of your plan', 'Damage due to floods, fires, or other natural disasters'].map((item, index) => <li key={index} className="flex items-start" data-id="element-623">
                  <XIcon size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-624" />
                  <span className="text-gray-700" data-id="element-625">{item}</span>
                </li>)}
            </ul>
          </section>
        </div>
        {/* Service Area Section */}
        <section className="mt-16 bg-white rounded-lg shadow-md p-8" data-id="element-626">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-627">
            Service Area
          </h2>
          <div className="flex items-start" data-id="element-628">
            <MapPinIcon size={24} className="text-[#f97316] mr-3 mt-1 flex-shrink-0" data-id="element-629" />
            <div data-id="element-630">
              <p className="text-gray-700 mb-4" data-id="element-631">
                We currently provide services across mainland UK postcodes only.
                For remote areas, response times may be longer. Please contact
                us to confirm if your location is covered.
              </p>
              <p className="text-gray-700" data-id="element-632">
                <strong data-id="element-633">Response Times:</strong> We aim to schedule engineer
                visits within 24 to 48 hours, excluding weekends and public
                holidays.
              </p>
            </div>
          </div>
        </section>
        {/* Plan Exclusions Section */}
        <section className="mt-16 bg-[#f8f9fa] border border-gray-200 rounded-lg p-8" data-id="element-634">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-635">
            Plan Exclusions & Prohibited Use
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-636">
            To ensure fair use and maintain service quality, the following are
            excluded from cover:
          </p>
          <ul className="space-y-2 text-gray-700" data-id="element-637">
            <li className="flex items-start" data-id="element-638">
              <div className="bg-red-100 p-1 rounded-full mr-3 mt-1" data-id="element-639">
                <XIcon size={14} className="text-red-500" data-id="element-640" />
              </div>
              <span data-id="element-641">Damage or faults existing before your plan started</span>
            </li>
            <li className="flex items-start" data-id="element-642">
              <div className="bg-red-100 p-1 rounded-full mr-3 mt-1" data-id="element-643">
                <XIcon size={14} className="text-red-500" data-id="element-644" />
              </div>
              <span data-id="element-645">Damage caused by neglect, misuse, or tampering</span>
            </li>
            <li className="flex items-start" data-id="element-646">
              <div className="bg-red-100 p-1 rounded-full mr-3 mt-1" data-id="element-647">
                <XIcon size={14} className="text-red-500" data-id="element-648" />
              </div>
              <span data-id="element-649">Repairs unrelated to normal appliance operation</span>
            </li>
            <li className="flex items-start" data-id="element-650">
              <div className="bg-red-100 p-1 rounded-full mr-3 mt-1" data-id="element-651">
                <XIcon size={14} className="text-red-500" data-id="element-652" />
              </div>
              <span data-id="element-653">
                Any illegal or fraudulent use of our services or website
              </span>
            </li>
            <li className="flex items-start" data-id="element-654">
              <div className="bg-red-100 p-1 rounded-full mr-3 mt-1" data-id="element-655">
                <XIcon size={14} className="text-red-500" data-id="element-656" />
              </div>
              <span data-id="element-657">Appliances used contrary to manufacturer instructions</span>
            </li>
          </ul>
          <p className="mt-4 text-gray-700 font-medium" data-id="element-658">
            Please note: If any of these exclusions apply, your plan may be
            cancelled without refund or further support.
          </p>
        </section>
      </div>
    </div>;
};
export default ServiceCoverage;